const VisualStatic = require('visual-static');

class Form extends VisualStatic {
  init() {
    this.orderOfFormFields = ['payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_phone', 'payer_tin_type', 'payer_tin', 'payee1_tin_type', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_accountnumber', 'payee1_2ndtinnotice', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_direct_sales', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_section409a_deferrals', 'payee1_section409a_income', 'payee1_statetax_with1', 'payee1_state1_name', 'payee1_state1_id', 'payee1_state_income1', 'payee1_statetax_with2', 'payee1_state2_name', 'payee1_state2_id', 'payee1_state_income2'];

    this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2', 'payee1_section409a_income', 'payee1_section409a_deferrals', 'payee1_accountnumber'];

    this.initOnReactComponentsMounted();
  }

  initBuilderOnReactComponentsMounted() {
    this.initBuilder();

    // Set the correct order of fields
    VisualStatic.setTabOrder(this.orderOfFormFields);

    // Remove labels (they are basically duplicates)
    VisualStatic.setPlaceholders(this.removeLabelsFromFields);

    VisualStatic.initExportPDF();
  }
}

module.exports = Form;



// WEBPACK FOOTER //
// ./src-assets/js/form-1099-misc-efile-2015.js